<template>
  <div>
    <p>Playlists in progress</p>
    <date-picker v-model="date"></date-picker>
  </div>
</template>

<script>
export default {
  name: 'playlist',
  data () {
    return {
      date: new Date()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/playlist/PlaylistList.vue